import { SchoolService, BaseService } from "@/services/school.service";

const ClubService = {
    getAll () {
        return SchoolService.getAll("clubs")
    },

    add(payload) {
        return SchoolService.create("clubs", payload)
    },

    update(object) {
        return SchoolService.update("clubs", object.identifier, object)
    },

    delete(object) {
        return SchoolService.delete("clubs", object.identifier, null)
    },

    // pupils

    getPupils(object) {
        return SchoolService.getAll("clubs/" + object.identifier + "/pupils")
    },

    deletePupil(result, object) {
        return SchoolService.delete("clubs/" + result.identifier + "/pupils", object.identifier, null) 
     },

     addPupil(payload) {
        return SchoolService.create("clubs/pupils", payload)
    },
     
}

export { ClubService };